import { render, staticRenderFns } from "./鉴证书详情.vue?vue&type=template&id=2e126bcc&scoped=true"
import script from "./鉴证书详情.vue?vue&type=script&lang=js"
export * from "./鉴证书详情.vue?vue&type=script&lang=js"
import style0 from "./鉴证书详情.vue?vue&type=style&index=0&id=2e126bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e126bcc",
  null
  
)

export default component.exports